module.exports = __webpack_public_path__ + "img/media-5.548df047.png";